import { Injectable } from '@angular/core';
import { UserSessionInfo } from '@common/models/user-session-info.model';
import { Router } from '@angular/router';
@Injectable({
  providedIn: 'root'
})
export class AuthService {

  constructor(private  router: Router) { }

  public static userSessionInfo:UserSessionInfo;
  public static sslPinningStatus:boolean;

  public static isLogged() {
    const sessionKey = sessionStorage.getItem('session-token')
    return !!sessionKey && sessionKey?.length > 0;
  }

  public static logout() {
    sessionStorage.removeItem('session-token');
    sessionStorage.removeItem('session-info');
    sessionStorage.removeItem('invest-flow');
  }

  public static getSessionToken(): string {
    const token = sessionStorage.getItem('session-token');
    return token ?  sessionStorage.getItem('session-token') : '';
  }

  public static setSessionToken(token:string) {
    sessionStorage.setItem('session-token', token);
  }

  public static setSessionInfo( info: UserSessionInfo){
    sessionStorage.setItem('session-info', JSON.stringify(info))
  }

  public static setInvestFlow(val:string) {
    sessionStorage.setItem('invest-flow', val);
  }

  public static getInvestFlow(): string {
    const token = sessionStorage.getItem('invest-flow');
    return token ?  sessionStorage.getItem('invest-flow') : '';
  }

  public static getSessionInfo():UserSessionInfo{
    const info =  sessionStorage.getItem('session-info');
    if(info){
      return JSON.parse(info);
    }
    return null;
  }

  public static setUserSessionInfo(info:UserSessionInfo ){
      this.userSessionInfo = info;
      this.setSessionInfo(this.userSessionInfo)
      if(this.userSessionInfo.sessionToken){
        this.setSessionToken(this.userSessionInfo.sessionToken)
      }
  }

  public static setSslPinningInfo(status){
    this.sslPinningStatus = status;
  }
  public static getSslPinningInfo(){
    return this.sslPinningStatus;
  }
}
